import { Calculate } from "@/api/api";
import format from "date-fns/format";

export const calculateFunc = (
  setIsLoading,
  startDate,
  endDate,
  promotionCode,
  localeData,
  entityId,
  currentRoutingTypeId,
  setWarning,
  setError,
  setResult,
  setPromotionError
) => {
  if (
    format(startDate, "yyyy-MM-dd", { locale: localeData }) !=
      format(endDate, "yyyy-MM-dd", { locale: localeData }) &&
    entityId != 1
  ) {
    setIsLoading(true);
    Calculate({
      start: format(startDate, "yyyy-MM-dd", {
        locale: localeData,
      }),
      end: format(endDate, "yyyy-MM-dd", { locale: localeData }),
      EntityId: entityId,
      currentRoutingTypeId,
      PromotionCode: promotionCode,
    })
      .then((response) => {
        setResult(response.data);
        !response.data.PromotionError &&
          localStorage.setItem("PromotionCode", promotionCode);
        if (response.data.apiResponse) {
          if (response.data.PromotionError) {
            setPromotionError(response.data.PromotionError);
          }
        }
        response.data.warning
          ? setWarning(response.data.warning)
          : setWarning(false);
        response.data.error ? setError(response.data.error) : setError(false);
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }
};
